import React from "react";
import Button from "@mui/material/Button";
import TimeAgo from "react-timeago";

// Workaround per bug di tipizzazione di react-timeago in alcune versioni
const TimeAgoFixed = (props) => <TimeAgo {...props} />;

// Definizione locale del componente DateFormatter (come in DateTypeProvider.js)
const DateFormatter = ({ value }) => {
  value = (!value) ? '0000-00-00 00:00:00' : value.trim();
  if (value === "0000-00-00 00:00:00") return <i>no info</i>;
  return (
    <b style={{ color: 'darkblue' }}>
      <TimeAgoFixed date={value} />
    </b>
  );
};

const UserSearchResultTable = ({ userSearchResults, onSelectUser }) => {
  if (!Array.isArray(userSearchResults) || userSearchResults.length === 0) return null;
  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ maxHeight: 'calc(100vh - 180px)', minHeight: 200, overflowY: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.97rem' }}>
          <thead>
            <tr style={{ background: '#f0f0f0' }}>
              <th style={{ padding: '4px 8px', border: '1px solid #ccc', textAlign: 'right', minWidth: 110 }}>Last activity</th>
              <th style={{ padding: '4px 8px', border: '1px solid #ccc', textAlign: 'right', minWidth: 90 }}>LR user code</th>
              <th style={{ padding: '4px 8px', border: '1px solid #ccc', minWidth: 140 }}>Name<br /><span style={{ fontWeight: 400, fontSize: '0.92em', color: '#888' }}>Username</span></th>
              <th style={{ padding: '4px 8px', border: '1px solid #ccc', minWidth: 180 }}>Company<br /><span style={{ fontWeight: 400, fontSize: '0.92em', color: '#888' }}>Email</span></th>
              <th style={{ padding: '4px 8px', border: '1px solid #ccc', minWidth: 60 }}>Country</th>
              <th style={{ padding: '4px 8px', border: '1px solid #ccc', minWidth: 1, width: 1, textAlign: 'center' }}>{' '}</th>
            </tr>
          </thead>
          <tbody>
            {userSearchResults.map(user => (
              <tr key={user.username}>
                <td style={{ padding: '4px 8px', border: '1px solid #ccc', textAlign: 'right', whiteSpace: 'nowrap' }}>                  {user.activity ? <DateFormatter value={user.activity} /> : ''}                </td>
                <td style={{ padding: '4px 8px', border: '1px solid #ccc', textAlign: 'right', fontWeight: 500 }}>{user.usercode}</td>
                <td style={{ padding: '4px 8px', border: '1px solid #ccc' }}>                  {user.name}                  <br />                  <span style={{ color: '#1976d2', fontSize: '0.93em', fontWeight: 400 }}>{user.username}</span>                </td>
                <td style={{ padding: '4px 8px', border: '1px solid #ccc' }}>                  {user.company}                  <br />                  <span style={{ color: '#1976d2', fontSize: '0.93em', fontWeight: 400 }}>{user.email}</span>                </td>
                <td style={{ padding: '4px 8px', border: '1px solid #ccc' }}>{user.country}</td>
                <td style={{ padding: '4px 8px', border: '1px solid #ccc', minWidth: 1, width: 1, textAlign: 'center' }}>                  <Button size="small" onClick={() => onSelectUser(user)}><b>SELECT</b></Button>                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserSearchResultTable;
